<template>
	<div class="answer__wrap answer-content position-rel" 
		:class="{'answer__err': !isDontShowResultSaved && statusCorrect === 'err', 
          'answer__true': (!isDontShowResultSaved && ( (statusCorrect === 'success' && !parent.isNoAnswer) || (statusCorrect === 'success' && parent.isNoAnswer && parent.type === types.TYPE_RADIO) || dataSource.success || ( parent.statusWorked && ((dataSource.content && dataSource.content === dataSource.correct) || (!dataSource.content && dataSource.answerContent))) ) ) || (isDontShowResultSaved && dataSource.answerContent && type === types.TYPE_RADIO)
      }"
	>
    <!-- 'answer__true': statusCorrect === 'success' || dataSource.success || (parent.statusWorked && dataSource.content === dataSource.correct && dataSource.answerContent) -->
    <!-- 'answer__true': (statusCorrect === 'success' || dataSource.success) && (parent.statusWorked && dataSource.content === dataSource.correct) -->
		<!-- 'answer__true': statusCorrect === 'success' || dataSource.success || (parent.statusWorked && dataSource.content === dataSource.correct) -->
		<template v-if="!isLoadChange">
			<MultipleChoice 
				v-if="type === types.TYPE_RADIO"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
				@changeAnswer="changeAnswer"
			/>
			<MultipleAnswer 
				v-else-if="type === types.TYPE_CHECKBOX || type === types.TYPE_X_MARK || type === types.TYPE_CIRCLE_ANSWER"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
				:statusCorrect="statusCorrect"
        :isDontShowResultSaved="isDontShowResultSaved"
				@changeAnswer="changeAnswer"
			/>
			<fillBlankOrSelect 
				v-else-if="type === types.TYPE_FILL_BLANK || type === types.TYPE_SELECT"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
        :isDontShowResultSaved="isDontShowResultSaved"
				@changeAnswer="changeAnswer"
			/>
			<MathCol 
				v-else-if="type === types.TYPE_MATH_COL"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
        :isDontShowResultSaved="isDontShowResultSaved"
				@changeAnswer="changeAnswer"
			/>
			<TrueFalseAnswer 
				v-else-if="type === types.TYPE_TRUE_FALSE_NO"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
				@changeAnswer="changeAnswer"
			/>
			<FillInputImg 
				v-else-if="type === types.TYPE_FILL_INPUT_IMG"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
				@changeAnswer="changeAnswer"
			/>
			<!-- <DrawShapeAnswer 
				v-else-if="type === types.TYPE_DRAW_SHAPE_ANSWER"
				:dataSource="dataSource"
				:nameField="nameField"
				:location="location"
				:parent="parent"
				@changeAnswer="changeAnswer"
			/> -->
			<EdittorCKAnswer
				v-else-if="type === types.TYPE_DOWN_ANSWER"
				:contentEditor="dataSource.answerContent"
				:fillBlank="false"
				:position="`answer_${dataSource.questionId}`"
			/>
		</template>
		<template v-else>
			<loading 
	      :active.sync="isLoadChange" 
	      :is-full-page="true"
	      color="#0f3dba"
	    />
		</template>
	</div>
</template>

<script>
	import * as types from './_store/constants'
	// import { CHANGE_TXT_ANSWER } from '@/modules/commons/_store/constants'
	// import { mapGetters, mapActions } from 'vuex'
	import Loading from 'vue-loading-overlay';

	export default {
		name: 'PreviewAnswerItem',
		props: {
			type: String, 
			dataSource: Object,
			nameField: String,
			location: Number,
			parent: Object,
			statusCorrect: String,
      isDontShowResultSaved: Boolean
		},
		components: {
			EdittorCKAnswer: () => import('@/modules/question/EdittorCKAnswer.vue'),
			MultipleChoice: () => import('./answers/multiple-choice/MultipleChoice.vue'),
			MultipleAnswer: () => import('./answers/multiple-answers/MultipleAnswer.vue'),
			fillBlankOrSelect: () => import('./answers/fill-blank-select/fillBlankOrSelect.vue'),
			FillInputImg: () => import('./answers/fill-input-img/FillInputImg.vue'),
			MathCol: () => import('./answers/math-col/MathCol.vue'),
			TrueFalseAnswer: () => import('./answers/true-false/TrueFalseAnswer.vue'),
			// DrawShapeAnswer: () => import('./answers/draw-shape/DrawShapeAnswer.vue'),
			Loading
		},
		data () {
			return {
				isLoadChange: false,
				types
			}
		},
		watch: {
			parent() {
				// Reset missing answer content
				this.isLoadChange = true;
				setTimeout(() => {
					this.isLoadChange = false;
				}, 1)
			}
		},
		// created() {
		// 	this.$bus.on(`${CHANGE_TXT_ANSWER}_0`, this.handleChangeTxtAnswer)
		// },
		// destroyed() {
		//     this.$bus.off(`${CHANGE_TXT_ANSWER}_0`, this.handleChangeTxtAnswer);
		// },
		methods: {

			changeAnswer(evt, data) {
				let valueEmit = {...data, evt, position: data.location};
				delete valueEmit.location;
				this.$emit('changeAnswer', valueEmit)
			},
			// handleChangeTxtAnswer(val) {
			// 	let valueEmit = {type: types.TYPE_DOWN_ANSWER, questionId: parseInt(val.question), value: val.html, position: 0};
			// 	this.$emit('changeAnswer', valueEmit)
			// }
		}
	}
</script>

<style lang="scss" scoped>
	.answer-val * {
		&:not(.msupsub) {
			font-size: 16px;
			color: #000;
		}
	}

	
	div.answer-down{
		background-image:
				-webkit-linear-gradient(right, rgba(255,255,255,1) 5%, rgba(255,255,255,1) 90%, rgba(255,255,255,0) 11%,rgba(255,255,255,0) 100%),
				-webkit-linear-gradient(bottom, rgba(128,128,128,1) 5%, rgba(128,128,128,0) 8%, rgba(128,128,128,0) 100%);
		-webkit-background-size: 12px 24px;
		-moz-background-size: 12px 24px;
		-ms-background-size: 12px 24px;
		-o-background-size: 12px 24px;
		background-size: 12px 24px;
		line-height: 31px;
		padding: 8px 10px;
		width: 100%;
		border: none;
		display: block;
		min-height: 80px;
	}

	.answer-fill-sentence:not(.answer-select-select) >label >b {padding-top: 3px;}
	.answer-fill-sentence >label >b {min-width: 30px; margin-right: 5px;}

	.sentence-content {
		margin-bottom: 8px;
		width: calc(100% - 35px);
	}

	.select-success, .select-error {
		display: inherit;
	}
	// .answer-match-item {
	// 	padding: 7px 10px;
	// }
	@media (max-width: 1024px){
		.sectence-content{
			overflow: auto !important;
		}
	}
</style>